import React, { useContext, useEffect, useRef, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import ArchivePage from './pages/ArchivePage';
import Flud from './pages/flud';
import './index.css'
import { useUserContext } from './context/UserContext';
import ContractorsPage from './pages/ContractorsPage';
import AdminPage from './pages/AdminPage';
import NotificationsPage from './pages/NotificationsPage';
import SocketContext from './context/SocketContext'; // Импорт сокета из контекста
import notify from './context/Notification'
import { useTaskContext } from './context/TaskContext';
import initMessaging from './components/Notifications';
import DashboardPage from './pages/DashboardPage';
import ReportsPage from './pages/ReportsPage';
import PricePage from './pages/PricePage';
import OrdersPage from './pages/OrdersPage';

function App() {
  const { socket } = useContext(SocketContext);
  const {isAuthenticated, checkout} = useUserContext();
  const {socketCreate, socketUpdate, socketDelete} = useTaskContext();
  const hasLoadedBefore = useRef(true);
  const [createTaskOpen, setCreateTaskOpen] = useState(false);
  
  useEffect(() => {
    // Проверка наличия сохранённого JWT-токена при загрузке страницы
    if (!isAuthenticated) {
      console.log("apprender")
      const token = localStorage.getItem('authToken');
      if (token) {
        checkout(token)
      } 
     }
  }, []);

    useEffect(() => {
    // Проверка наличия сохранённого JWT-токена при загрузке страницы
    socket?.on('connect', () => {
        const notificationToken = localStorage.getItem('notificationToken');
        if (notificationToken === null) {
          initMessaging()
        }
        console.log('Connected to Socket.IO server');
      });
      socket?.on('createTask', (data) => {
        socketCreate(data)
        notify("Создана задача: " + data.name)
      })
      socket?.on('updateTask', (data) => {
        debugger
        socketUpdate(data._id, data)
        notify("Обновлена задача: " + data.name)
      })
      socket?.on('deleteTask', (data) => {
        socketDelete(data._id)
        notify("Удалена задача: " + data.name)
      })
  }, [socket]);

  useEffect(() => {
    if(hasLoadedBefore.current){
      hasLoadedBefore.current = false;
    }
  }, [isAuthenticated]);
  return (
    <div className="app-layout">
      {isAuthenticated && (
        <Sidebar onCreateTask={() => setCreateTaskOpen(true)} />
      )}
      <main className={`app-main ${!isAuthenticated ? 'app-main--full' : ''}`}>
        <Routes>
          {/* Домашняя — теперь стартовая */}
          <Route path="/" element={
            !isAuthenticated
              ? <Navigate to="/login" replace />
              : <DashboardPage
                  externalCreateOpen={createTaskOpen}
                  onExternalCreateClose={() => setCreateTaskOpen(false)}
                />
          }/>

          {/* Канбан — теперь на /board */}
          <Route path="/board" element={
            !isAuthenticated
              ? <Navigate to="/login" replace />
              : <HomePage
                  externalCreateOpen={createTaskOpen}
                  onExternalCreateClose={() => setCreateTaskOpen(false)}
                />
          }/>
          <Route path="/contractors" element={
            !isAuthenticated ? <Navigate to="/login"/> : <ContractorsPage/>
          }/>
          <Route path="/price" element={ !isAuthenticated ? <Navigate to="/login"/> : <PricePage/> } />
          <Route path="/orders" element={ !isAuthenticated ? <Navigate to="/login"/> : <OrdersPage/> } />
          <Route path="/archive" element={
            !isAuthenticated ? <Navigate to="/login"/> : <ArchivePage/>
          }/>
          <Route path="/reports" element={
            !isAuthenticated ? <Navigate to="/login"/> : <ReportsPage/>
          }/>
          <Route path="/flud" element={
            !isAuthenticated ? <Navigate to="/login"/> : <Flud/>
          }/>
          <Route path="/notifications" element={
            !isAuthenticated ? <Navigate to="/login"/> : <NotificationsPage/>
          }/>
          <Route path="/adminpanel" element={
            !isAuthenticated ? <Navigate to="/login"/> : <AdminPage/>
          }/>
          <Route exact path="/login" element={<LoginPage/>} />
        </Routes>
      </main>
    </div>
  );
}

export default App;